import React, { useState, useRef, useEffect } from 'react';
import styles from './style.module.css';
import api from '../../api';

// const GOALS = [
//     { id: '1', label: 'Feel healthier', value: 'Feel healthier' },
//     { id: '2', label: 'Build better habits', value: 'Build better habits' },
//     { id: '3', label: 'Understand myself', value: 'Understand myself' },
//     { id: '4', label: 'Stay curious', value: 'Stay curious' }
// ];

const GOALS = [
    { "_id": "5f6966b8c1dea16c89b1f9ae", "name": "Healthy Living", "secondaryInfo": { "description": "Pursue an overarching goal of health and wellness in every area of life.", "thumbnail": null, "photo": null }, "archived": false, "date": "2020-09-22T02:51:36.598Z" },
    { "_id": "5f6966b9c1dea16c89b1f9af", "name": "Weight Management", "secondaryInfo": { "description": "Modify your lifestyle to maintain a healthy body weight and stay fit.", "thumbnail": null, "photo": null }, "archived": false, "date": "2020-09-22T02:51:37.249Z" },
    { "_id": "5f6966b9c1dea16c89b1f9b0", "name": "Heart Health", "secondaryInfo": { "description": "Improve your heart health by setting manageable goals.", "thumbnail": null, "photo": null }, "archived": false, "date": "2020-09-22T02:51:37.664Z" },
    { "_id": "5f6966bac1dea16c89b1f9b1", "name": "Diabetes Control", "secondaryInfo": { "description": "Keep diabetes symptoms in remission by adopting your fitness goals.", "thumbnail": null, "photo": null }, "archived": false, "date": "2020-09-22T02:51:38.148Z" },
    { "_id": "5f6966bac1dea16c89b1f9b2", "name": "Other", "secondaryInfo": { "description": null, "thumbnail": null, "photo": null }, "archived": false, "date": "2020-09-22T02:51:38.611Z" }
];

const AREAS = [
    { "_id": "5f6a0e795b82f14687c0844c", "name": "Citra", "description": "", "zip": "32113", "archived": false, "date": "2020-09-22T14:47:21.639Z" },
    { "_id": "5f6a0e795b82f14687c0844d", "name": "Salt Springs", "description": "", "zip": "32134", "archived": false, "date": "2020-09-22T14:47:21.828Z" },
    { "_id": "5f6a0e795b82f14687c0844e", "name": "Fort McCoy", "description": "", "zip": "32134", "archived": false, "date": "2020-09-22T14:47:21.998Z" },
    { "_id": "5f6a0e7a5b82f14687c0844f", "name": "Ocklawaha", "description": "", "zip": "32179", "archived": false, "date": "2020-09-22T14:47:22.175Z" },
    { "_id": "5f6a0e7a5b82f14687c08450", "name": "Weirsdale", "description": "", "zip": "32195", "archived": false, "date": "2020-09-22T14:47:22.339Z" },
    { "_id": "5f6a0e7a5b82f14687c08451", "name": "Anthony", "description": "", "zip": "32617", "archived": false, "date": "2020-09-22T14:47:22.504Z" },
    { "_id": "5f6a0e7a5b82f14687c08452", "name": "Reddick", "description": "", "zip": "32686", "archived": false, "date": "2020-09-22T14:47:22.666Z" },
    { "_id": "5f6a0e7a5b82f14687c08453", "name": "Irvine", "description": "", "zip": "32686", "archived": false, "date": "2020-09-22T14:47:22.822Z" },
    { "_id": "5f6a0e7a5b82f14687c08454", "name": "Flemington", "description": "", "zip": "32686", "archived": false, "date": "2020-09-22T14:47:22.978Z" },
    { "_id": "5f6a0e7b5b82f14687c08455", "name": "Belleview", "description": "", "zip": "34420", "archived": false, "date": "2020-09-22T14:47:23.153Z" },
    { "_id": "5f6a0e7b5b82f14687c08456", "name": "Dunnellon", "description": "", "zip": "34431", "archived": false, "date": "2020-09-22T14:47:23.313Z" },
    { "_id": "5f6a0e7b5b82f14687c08457", "name": "Dunnellon", "description": "", "zip": "34432", "archived": false, "date": "2020-09-22T14:47:23.496Z" },
    { "_id": "5f6a0e7b5b82f14687c08458", "name": "Ocala", "description": "", "zip": "34470", "archived": false, "date": "2020-09-22T14:47:23.657Z" },
    { "_id": "5f6a0e7b5b82f14687c08459", "name": "Ocala", "description": "", "zip": "34471", "archived": false, "date": "2020-09-22T14:47:23.823Z" },
    { "_id": "5f6a0e7b5b82f14687c0845a", "name": "Maricamp", "description": "", "zip": "34471", "archived": false, "date": "2020-09-22T14:47:23.983Z" },
    { "_id": "5f6a0e7c5b82f14687c0845b", "name": "Maricamp", "description": "", "zip": "34472", "archived": false, "date": "2020-09-22T14:47:24.149Z" },
    { "_id": "5f6a0e7c5b82f14687c0845c", "name": "Ocala", "description": "", "zip": "34472", "archived": false, "date": "2020-09-22T14:47:24.309Z" },
    { "_id": "5f6a0e7c5b82f14687c0845d", "name": "Ocala", "description": "", "zip": "34473", "archived": false, "date": "2020-09-22T14:47:24.471Z" },
    { "_id": "5f6a0e7c5b82f14687c0845e", "name": "Ocala", "description": "", "zip": "34474", "archived": false, "date": "2020-09-22T14:47:24.640Z" },
    { "_id": "5f6a0e7c5b82f14687c0845f", "name": "Ocala", "description": "", "zip": "34475", "archived": false, "date": "2020-09-22T14:47:24.799Z" },
    { "_id": "5f6a0e7c5b82f14687c08460", "name": "Ocala", "description": "", "zip": "34476", "archived": false, "date": "2020-09-22T14:47:24.976Z" },
    { "_id": "5f6a0e7d5b82f14687c08461", "name": "Ocala", "description": "", "zip": "34479", "archived": false, "date": "2020-09-22T14:47:25.140Z" },
    { "_id": "5f6a0e7d5b82f14687c08462", "name": "Maricamp", "description": "", "zip": "34480", "archived": false, "date": "2020-09-22T14:47:25.310Z" },
    { "_id": "5f6a0e7d5b82f14687c08463", "name": "Ocala", "description": "", "zip": "34480", "archived": false, "date": "2020-09-22T14:47:25.485Z" },
    { "_id": "5f6a0e7d5b82f14687c08464", "name": "Ocala", "description": "", "zip": "34481", "archived": false, "date": "2020-09-22T14:47:25.648Z" },
    { "_id": "5f6a0e7d5b82f14687c08465", "name": "Ocala", "description": "", "zip": "34482", "archived": false, "date": "2020-09-22T14:47:25.818Z" },
    { "_id": "5f6a0e7d5b82f14687c08466", "name": "Silver Springs", "description": "", "zip": "34488", "archived": false, "date": "2020-09-22T14:47:25.976Z" },
    { "_id": "5f6a0e7e5b82f14687c08467", "name": "Summerfield", "description": "", "zip": "34491", "archived": false, "date": "2020-09-22T14:47:26.133Z" }
];

export default function OnboardingApp(props) {
    const [currentStep, setCurrentStep] = useState(0);
    const [transitioning, setTransitioning] = useState(false);
    const [leavingStep, setLeavingStep] = useState(null);

    // Form State
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [phoneInvalid, setPhoneInvalid] = useState(false);
    const [phoneHint, setPhoneHint] = useState('Standard message rates may apply');
    const [code, setCode] = useState(['', '', '', '']);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [goal, setGoal] = useState('');
    const [birthday, setBirthday] = useState('');
    const [unit, setUnit] = useState('imperial'); // 'imperial' | 'metric'
    const [height, setHeight] = useState(68);
    const [weight, setWeight] = useState(165);
    const [type, setType] = useState(null);
    const [area, setArea] = useState(null);
    const [existingName, setExistingName] = useState('');

    // UI State
    const [toastMessage, setToastMessage] = useState('');
    const [isToastVisible, setIsToastVisible] = useState(false);

    const codeInputsRef = useRef([]);
    const formRef = useRef(null);

    // Calculate maximum date of birth (13 years ago today)
    const maxBirthday = new Date(
        new Date().setFullYear(new Date().getFullYear() - 13)
    ).toISOString().split('T')[0];

    const showToast = (msg) => {
        setToastMessage(msg);
        setIsToastVisible(true);
        setTimeout(() => {
            setIsToastVisible(false);
        }, 1800);
    };

    const digits = (val) => val.replace(/\D/g, '');

    const formatPhone = (val) => {
        const number = digits(val).slice(0, 10);
        if (number.length < 4) return number;
        if (number.length < 7) return `(${number.slice(0, 3)}) ${number.slice(3)}`;
        return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
    };

    const handlePhoneInput = (e) => {
        setPhone(formatPhone(e.target.value));
        setPhoneInvalid(false);
        setPhoneHint('Standard message rates may apply');
    };

    const goToStep = (next) => {
        if (transitioning || next < 0 || next > 7) return;
        setTransitioning(true);
        setLeavingStep(currentStep);

        setTimeout(() => {
            setLeavingStep(null);
            setCurrentStep(next);
            setTransitioning(false);
        }, 330);
    };

    const authenticate = async phone => {
        try {
            const result = await api.auth.initial(phone);
            setType(result.existing ? 'existing' : 'new');
            goToStep(1);
        } catch (e) {
            showToast('Error occurred, try again.');
        }
    };

    const addition = async (code) => {
        const result = await api.auth.verifyCode('1' + digits(phone), code);

        if (!result) {
            showToast('Error occurred, try again.');
            return;
        }

        props.onAuth(result);
        goToStep(2);
    };

    const existing = async (code) => {
        const result = await api.auth.verifyCode('1' + digits(phone), code);

        if (!result) {
            showToast('Error occurred, try again.');
            return;
        }

        props.onAuth(result);
        if (result.user && result.user.firstName) setExistingName(result.user.firstName);
        goToStep(7);
    };

    const resume = (code) => {
        console.log(code);
        if (type === 'existing') existing(code.join(''));
        if (type === 'new') addition(code.join(''));
    };

    const handleCodeChange = (index, value) => {
        const pasted = digits(value);
        const newCode = [...code];

        if (pasted.length > 1) {
            // Paste from the current active index onward
            const chars = pasted.slice(0, 4 - index).split('');
            chars.forEach((char, i) => {
                newCode[index + i] = char;
            });

            setCode(newCode);

            const nextEmptyIndex = newCode.findIndex((item) => !item);
            if (nextEmptyIndex !== -1) {
                codeInputsRef.current[nextEmptyIndex]?.focus();
            } else {
                // Focus last input if all filled
                codeInputsRef.current[3]?.focus();
                setTimeout(() => resume(newCode), 180);
            }
        } else {
            // Single character typed or deleted
            const char = pasted.slice(-1);
            newCode[index] = char;
            setCode(newCode);

            if (char && index < 3) {
                // Move forward on type
                codeInputsRef.current[index + 1]?.focus();
            } else if (!char && index > 0) {
                // Move backward on backspace
                codeInputsRef.current[index - 1]?.focus();
            }

            if (newCode.every((digit) => digit !== '')) {
                setTimeout(() => resume(newCode), 180);
            }
        }
    };

    // // Code input logic
    // const handleCodeChange = (index, value) => {
    //     const pasted = digits(value);
    //     const newCode = [...code];

    //     if (pasted.length > 1) {
    //         const digitsArr = pasted.slice(0, 4).split('');
    //         digitsArr.forEach((digit, i) => {
    //             newCode[i] = digit;
    //         });
    //         setCode(newCode);
    //         const nextEmptyIndex = newCode.findIndex((item) => !item);
    //         if (nextEmptyIndex !== -1) {
    //             codeInputsRef.current[nextEmptyIndex]?.focus();
    //         } else {
    //             setTimeout(() => resume(), 180);
    //         }
    //     } else {
    //         newCode[index] = pasted.slice(-1);
    //         setCode(newCode);
    //         if (pasted && index < 3) {
    //             codeInputsRef.current[index + 1]?.focus();
    //         }
    //         if (newCode.every((digit) => digit !== '')) {
    //             setTimeout(() => resume(), 180);
    //         }
    //     }
    // };

    const updateName = async () => {
        try {
            await api.accounts.AddUserInfo({
                firstName,
                lastName
            });

            try {
                localStorage.setItem('contacted', "true");
                await api.auth.updateContact(email);
            } catch (e) { console.log(e) }

            goToStep(3);
            // props.updateProfile();
        } catch (e) {
            showToast('Error occurred, try again.');
        }
    };

    const updateGoals = async goal => {
        try {
            await api.goals.setAppGoal(goal);
            goToStep(4);
            // props.updateProfile();
        } catch (e) {
            showToast('Error occurred, try again.');
        }
    };

    const updateBirthday = async (value) => {
        try {
            const [year, month, day] = value.split('-');
            const formatted = `${month}-${day}-${year}`;

            await api.accounts.AddUserInfo({
                secondaryInfo: {
                    birthday: formatted // `${updates.birthdayMonth || 1}-${updates.birthdayDay || 1}-${updates.birthdayYear || 1980}`
                }
            });

            goToStep(5);
        } catch (e) {
            showToast('Error occurred, try again.');
        }
    }

    const updateWeight = async (height, weight) => {
        try {
            await api.accounts.AddUserInfo({
                secondaryInfo: {
                    heightCentimeters: height,
                    weightKilograms: weight
                }
            });

            goToStep(6);
        } catch (e) {
            showToast('Error occurred, try again.');
        }
    }

    const updateArea = async (value) => {
        try {
            await api.accounts.AddUserInfo({
                secondaryInfo: {
                    area: value
                }
            });

            goToStep(7);
        } catch (e) {
            showToast('Error occurred, try again.');
        }
    }

    const handleCodeKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !code[index] && index > 0) {
            codeInputsRef.current[index - 1]?.focus();
        }
    };

    const handleCodePaste = (e) => {
        e.preventDefault();
        const pasted = digits(e.clipboardData.getData('text')).slice(0, 4);
        const newCode = ['', '', '', ''];
        pasted.split('').forEach((digit, i) => {
            newCode[i] = digit;
        });
        setCode(newCode);
        if (pasted.length === 4) {
            setTimeout(() => resume(), 180);
        } else {
            codeInputsRef.current[pasted.length]?.focus();
        }
    };

    // Form submit handler per step
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (currentStep === 0) {
            if (digits(phone).length !== 10) {
                setPhoneInvalid(true);
                setPhoneHint('Enter a complete 10-digit number');
                return;
            }

            authenticate('1' + digits(phone));
            // goToStep(1);
        } else if (currentStep === 2) {
            if (!firstName.trim() || !lastName.trim()) {
                formRef.current.reportValidity();
                return;
            }
            updateName();
        } else if (currentStep === 4) {
            if (!birthday) {
                formRef.current.reportValidity();
                return;
            }
            updateBirthday(birthday);
        } else if (currentStep === 5) {
            if (!height || !weight) {
                formRef.current.reportValidity();
                return;
            }
            updateWeight(height, weight);
        } else if (currentStep === 6) {
            if (!area) {
                showToast('Select an area first');
                return;
            }

            updateArea(area);
        }
    };

    const getStepClass = (stepIndex) => {
        if (currentStep === stepIndex && leavingStep !== stepIndex) {
            return `${styles.step} ${styles.isActive}`;
        }
        if (leavingStep === stepIndex) {
            return `${styles.step} ${styles.isActive} ${styles.isLeaving}`;
        }
        return styles.step;
    };

    return (
        <main className={styles.onboarding}>
            <form
                ref={formRef}
                className={styles.flow}
                id="onboardingForm"
                noValidate
                onSubmit={handleSubmit}
            >
                {/* Step 01: Phone Number */}
                <section
                    className={getStepClass(0)}
                    data-step="0"
                    inert={currentStep !== 0 ? '' : undefined}
                >
                    <div className={styles.stepCopy}>
                        <p className={styles.eyebrow}>
                            <span>1</span>
                        </p>
                        <h1>Welcome to <br /><em>Active Marion Project</em></h1>
                        <p className={styles.support}>
                            We’ll text you a one-time code.
                        </p>
                    </div>
                    <label className={`${styles.field} ${styles.phoneField} ${phoneInvalid ? styles.isInvalid : ''}`}>
                        {/* <span className={styles.fieldLabel}>MOBILE NUMBER</span> */}
                        <span className={styles.phoneInput}>
                            <button type="button" aria-label="Country code, United States">
                                🇺🇸 <span>+1</span>
                            </button>
                            <input
                                id="phone"
                                name="phone"
                                type="tel"
                                inputMode="numeric"
                                autoComplete="tel-national"
                                placeholder="(555) 000-0000"
                                maxLength="14"
                                required
                                value={phone}
                                onChange={handlePhoneInput}
                            />
                        </span>
                        {/* <span className={styles.fieldHint}>{phoneHint}</span> */}
                    </label>
                    <button className={styles.primary} type="submit">
                        <span>Send my code</span>
                    </button>
                </section>

                {/* Step 02: Verification Code */}
                <section
                    className={getStepClass(1)}
                    data-step="1"
                    inert={currentStep !== 1 ? '' : undefined}
                >
                    <div className={styles.stepCopy}>
                        <p className={styles.eyebrow}>
                            <span>2</span>
                        </p>
                        {type === 'existing' ? <h1>Welcome back!</h1> : <h1>Looks like you're<br />new here!</h1>}
                        <p className={styles.support}>
                            Enter the code sent to{' '}
                            <button
                                className={styles.textButton}
                                type="button"
                                onClick={() => goToStep(0)}
                            >
                                +1 {phone}
                            </button>
                        </p>
                    </div>
                    <fieldset className={styles.codeField}>
                        <div className={styles.codeInputs}>
                            {code.map((digit, idx) => (
                                <input
                                    key={idx}
                                    ref={(el) => (codeInputsRef.current[idx] = el)}
                                    aria-label={`Digit ${idx + 1}`}
                                    inputMode="numeric"
                                    autoComplete={idx === 0 ? 'one-time-code' : undefined}
                                    maxLength={1}
                                    value={digit}
                                    onChange={(e) => handleCodeChange(idx, e.target.value)}
                                    onKeyDown={(e) => handleCodeKeyDown(idx, e)}
                                    onPaste={idx === 0 ? handleCodePaste : undefined}
                                />
                            ))}
                        </div>
                    </fieldset>
                </section>

                {/* Step 03: Name */}
                <section
                    className={getStepClass(2)}
                    data-step="2"
                    inert={currentStep !== 2 ? '' : undefined}
                >
                    <div className={styles.stepCopy}>
                        <p className={styles.eyebrow}>
                            <span>3</span>
                        </p>
                        <h1>Hi there,<br />what's your name?</h1>
                        <p className={styles.support}>
                            You can change this later.
                        </p>
                    </div>
                    <div className={styles.fieldGrid}>
                        <label className={styles.field}>
                            <input
                                id="firstName"
                                name="firstName"
                                autoComplete="given-name"
                                placeholder="First Name"
                                required
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                            />
                        </label>
                        <label className={styles.field}>
                            <input
                                id="lastName"
                                name="lastName"
                                autoComplete="family-name"
                                placeholder="Last Name"
                                required
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                            />
                        </label>
                        <label className={styles.field}>
                            <input
                                id="email"
                                name="email"
                                autoComplete="email"
                                placeholder="Email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </label>
                    </div>
                    <button className={styles.primary} type="submit">
                        <span>Continue</span>
                    </button>
                </section>

                {/* Step 04: Main Goal */}
                <section
                    className={getStepClass(3)}
                    data-step="3"
                    inert={currentStep !== 3 ? '' : undefined}
                >
                    <div className={styles.stepCopy}>
                        <p className={styles.eyebrow}>
                            <span>4</span>
                        </p>
                        <h1>What brings you<br /><em>here?</em></h1>
                        <p className={styles.support}>
                            Pick one for now. We'll use this to better help you.
                        </p>
                    </div>
                    <div className={styles.goalList} role="radiogroup" aria-label="Main goal">
                        {GOALS.map((g) => (
                            <button
                                key={g._id}
                                type="button"
                                role="radio"
                                aria-checked={goal === g.value ? 'true' : 'false'}
                                onClick={() => {
                                    setGoal(g._id);
                                    setTimeout(() => updateGoals(g._id), 240);
                                }}
                            >
                                <span>{g.id}</span>
                                <b>{g.name}</b>
                                <i />
                            </button>
                        ))}
                    </div>
                </section>

                {/* Step 05: Date of Birth */}
                <section
                    className={getStepClass(4)}
                    data-step="4"
                    inert={currentStep !== 4 ? '' : undefined}
                >
                    <div className={styles.stepCopy}>
                        <p className={styles.eyebrow}>
                            <span>5</span>
                        </p>
                        <h1>When's your birthday?</h1>
                        <p className={styles.support}>
                            Your age helps us tailor your experience.
                        </p>
                    </div>
                    <label className={`${styles.field} ${styles.dateField}`}>
                        <input
                            id="birthday"
                            name="birthday"
                            type="date"
                            autoComplete="bday"
                            max={maxBirthday}
                            required
                            value={birthday}
                            onChange={(e) => setBirthday(e.target.value)}
                        />
                    </label>
                    <button className={styles.primary} type="submit">
                        <span>Continue</span>
                    </button>
                </section>

                {/* Step 06: Measurements */}
                <section
                    className={getStepClass(5)}
                    data-step="5"
                    inert={currentStep !== 5 ? '' : undefined}
                >
                    <div className={styles.stepCopy}>
                        <p className={styles.eyebrow}>
                            <span>6</span>
                        </p>
                        <h1>Establish your<br /><em>baseline.</em></h1>
                        <p className={styles.support}>
                            Enter your height and weight to help establish your starting point.
                        </p>
                    </div>
                    <div className={styles.measurementGrid}>
                        <label className={styles.measurement}>
                            <div>
                                <input
                                    id="height"
                                    name="height"
                                    type="number"
                                    inputMode="decimal"
                                    min={unit === 'metric' ? 90 : 36}
                                    max={unit === 'metric' ? 245 : 96}
                                    value={height}
                                    onChange={(e) => setHeight(Number(e.target.value))}
                                    required
                                />
                                <b>{unit === 'metric' ? 'cm' : 'in'}</b>
                            </div>
                        </label>
                        <label className={styles.measurement}>
                            <div>
                                <input
                                    id="weight"
                                    name="weight"
                                    type="number"
                                    inputMode="decimal"
                                    min={unit === 'metric' ? 30 : 70}
                                    max={unit === 'metric' ? 320 : 700}
                                    value={weight}
                                    onChange={(e) => setWeight(Number(e.target.value))}
                                    required
                                />
                                <b>{unit === 'metric' ? 'kg' : 'lb'}</b>
                            </div>
                        </label>
                    </div>
                    <button className={styles.primary} type="submit">
                        <span>Continue</span>
                    </button>
                </section>

                <section
                    className={getStepClass(6)}
                    data-step="6"
                    inert={currentStep !== 6 ? '' : undefined}
                >
                    <div className={styles.stepCopy}>
                        <p className={styles.eyebrow}>
                            <span>7</span>
                        </p>
                        <h1>Choose your <br />zip code.</h1>
                        <p className={styles.support}>
                            What part of town are you based?
                        </p>
                    </div>
                    <div className={styles.goalList} role="radiogroup" aria-label="Main goal">
                        {AREAS.map((g) => (
                            <button
                                key={g._id}
                                type="button"
                                role="radio"
                                aria-checked={goal === g.value ? 'true' : 'false'}
                                onClick={() => {
                                    setArea(g._id);
                                    setTimeout(() => updateArea(g._id), 240);
                                }}
                            >
                                <span>{g.id}</span>
                                <b>{g.zip} ({g.name})</b>
                                <i />
                            </button>
                        ))}
                    </div>
                </section>

                {/* Complete State */}
                <section
                    className={`${getStepClass(7)} ${styles.stepComplete}`}
                    data-step="6"
                    inert={currentStep !== 7 ? '' : undefined}
                >
                    <div className={styles.stComplete} aria-hidden="true">
                        <i /><i /><div className={styles.greetingIcon} />
                    </div>
                    {existingName.length ? <h1>Welcome back to<br />AMP, <em>{existingName}</em></h1> : <h1>Welcome to<br />AMP, <em>{firstName}</em></h1>}
                    {/* <h1>Welcome to<br />AMP, <em>{firstName || 'friend'}!</em></h1> */}
                    <p className={styles.support}>
                        {existingName.length ? `Let's get you back on track.` : `We're excited you've decided to join us.`}
                    </p>
                    <button
                        className={styles.primary}
                        type="button"
                        onClick={() => { setTimeout(() => props.history.push('/'), 1000); }}
                    >
                        <span>Start Using AMP</span>
                    </button>
                </section>
            </form>

            <button
                className={`${styles.backButton} ${currentStep > 0 && currentStep < 7 ? styles.isVisible : ''}`}
                type="button"
                aria-label="Go back"
                onClick={() => goToStep(currentStep - 1)}
            >
                ← <span>BACK</span>
            </button>

            <div
                className={`${styles.toast} ${isToastVisible ? styles.isVisible : ''}`}
                role="status"
            >
                {toastMessage}
            </div>
        </main>
    );
}